// vuex module: refineryConfig
// manages global refinery calculation settings fetched from platformgold-api

import request from '@/util/request'

const state = {
  refinerySettings: {},
  refinerySettingsLoaded: false,
}

const getters = {
  refinerySettings: (state) => state.refinerySettings,
  refinerySetting: (state) => (key, def = null) => (key in state.refinerySettings ? state.refinerySettings[key] : def),
  refinerySettingsLoaded: (state) => state.refinerySettingsLoaded,
}

const actions = {
  async fetchRefinerySettings({ commit, state }) {
    // only skip if loaded AND has actual settings
    const hasSettings = state.refinerySettings && Object.keys(state.refinerySettings).length > 0
    if (state.refinerySettingsLoaded && hasSettings) return // cache
    
    try {
      const data = await request.get('/refinery/settings')
      commit('SET_REFINERY_SETTINGS', data)
    } catch (e) {
      console.error('failed to load refinery settings', e)
    }
  },
}

const mutations = {
  SET_REFINERY_SETTINGS(state, settings) {
    state.refinerySettings = settings || {}
    state.refinerySettingsLoaded = true
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
} 